/**
 * Format LinkedIn title + company for profile/home cards.
 * Never smash with " - ". Avoid duplicating company when title already contains it.
 * Returns '' when both empty (caller should hide).
 */
export function formatTitleCompany(title, company) {
  const t = (title || '').trim();
  const c = (company || '').trim();
  if (!t && !c) return '';
  if (!t) return c;
  if (!c) return t;
  const tLower = t.toLowerCase();
  const cLower = c.toLowerCase();
  // Company only when different from title (e.g. "Founder of Hang" + "Hang")
  if (
    tLower === cLower ||
    tLower.includes(cLower) ||
    tLower.endsWith(` ${cLower}`) ||
    tLower.endsWith(` of ${cLower}`) ||
    tLower.endsWith(` @ ${cLower}`) ||
    tLower.endsWith(` at ${cLower}`)
  ) {
    return t;
  }
  return `${t} · ${c}`;
}

export default formatTitleCompany;
